/**********************************************************************
// @@@ START COPYRIGHT @@@
//        AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
//        Copyright 2018 - 2019
//        Avi Solar Energy Pvt Ltd.
//        Protected as an unpublished work.
//  The computer program listings, specifications and documentation
//  herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
//  and shall not be reproduced, copied, disclosed, or used in whole or in part for
//  any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/
<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <div class="text-xs-center">
        <div class="header font-weight-bold">404</div>
        <div class="sub-header">{{ $t('Page Not Found') }}</div>
        <div class="message">
          <div>{{ $t('Sorry! The page you are requesting doesn\'t exist.') }}</div>
          <div>{{ $t('You can go back to') }} <span @click="goBackHandler" class="link">{{ $t('previous page') }}</span></div>
        </div>
      </div>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  methods: {
    goBackHandler() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      }
    }
  }
}
</script>

<style scoped>
  .header {
    font-size: 300px;
    line-height: 250px;
    color: var(--primarytext);
  }

  .sub-header {
    font-size: 80px;
    line-height: 45px;
    color: var(--primarytext);
    margin-bottom: 10px;
  }

  .message {
    margin-top: 30px;
    font-size: 16px;
  }

  .link {
    color: #E9952A;
    font-weight: 700;
  }

  .link:hover {
    cursor: pointer;
    text-decoration: underline;
  }

  @media (max-width: 630px) {
    .header {
      font-size: 150px;
      line-height: 125px;
    }
    .sub-header {
      font-size: 40px;
    }
    .message {
      margin-top: 10px;
    }
  }
</style>
